// Get status badge color
export const getStatusColor = (status: string): string => {
  switch (status) {
    case "TicketsReserved":
      return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100";
    case "ManualPurchase":
      return "bg-orange-100 text-orange-800 hover:bg-orange-100";
    case "AwaitingUserPayment":
      return "bg-blue-100 text-blue-800 hover:bg-blue-100";
    case "PaymentFailed":
    case "PurchaseError":
      return "bg-red-100 text-red-800 hover:bg-red-100";
    case "PaymentCompleted":
    case "PurchaseSucceeded":
    case "Success":
      return "bg-green-100 text-green-800 hover:bg-green-100";
    default:
      return "bg-gray-100 text-gray-800 hover:bg-gray-100";
  }
};

// Get status badge color
export const getStatusHexColor = (status: string): string => {
  switch (status) {
    case "TicketsReserved":
      return "#FEF08A"; // 2 notes higher than #FEF9C3
    case "ManualPurchase":
      return "#FDBA74"; // 2 notes higher than #FFEDD5
    case "AwaitingUserPayment":
      return "#93C5FD"; // 2 notes higher than #DBEAFE
    case "PaymentFailed":
    case "PurchaseError":
      return "#FCA5A5"; // 2 notes higher than #FEE2E2
    case "PaymentCompleted":
    case "PurchaseSucceeded":
    case "Success":
      return "#86EFAC"; // 2 notes higher than #DCFCE7
    default:
      return "#D1D5DB"; // 2 notes higher than #F3F4F6
  }
};
